import React from 'react';
export const WixStyleReactMaskingContext = React.createContext({});
//# sourceMappingURL=context.js.map